module.exports = __webpack_public_path__ + "img/4-3.0c0ce16d.svg";